import { v4 as uuidv4 } from "uuid";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import {
  getColorOptions,
  getTextAlignOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { defaultData as defaultPData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P2BlockDefaultData";
import { createButtonBlock } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/createButtonBlock";
import { defaultData as defaultH1Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H1Block/H1BlockDefaultData";
import { getAlignmentOptions } from "../../../Utils/buttonStyleHelpers";
import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HeroBlock6",
  props: {
    imageContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          baseData: defaultImageData,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "427px",
                maxWidth: "none",
                width: "100%",
                height: "auto",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "0",
                marginBottom: "0",
                marginLeft: "0",
                marginRight: "0",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 0,
                border_left_bottom_radius: 0,
                border_right_top_radius: 0,
                border_right_bottom_radius: 0,
              },
            }),
          },
        }),
      ],
    },
    headerContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Heading",
          baseData: defaultH1Data,
          styles: {
            textAlign: getTextAlignOptions("left"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
        createPBlock({
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat.",
          baseData: defaultPData,
          paragraphStyle: "p2",
          styles: {
            textAlign: getTextAlignOptions("left"),
            color: getColorOptions("#545861"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    primaryButton: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Button",
          href: "#",
          buttonType: "primaryButton",
          styles: {
            alignment: getAlignmentOptions("left"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "12",
                marginBottom: "12",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
